import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import ScheduleGradeCommentsEdit from './ScheduleGradeCommentsEdit';
import Select from 'react-select';

class ScheduleGradeCommentsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      regimes_select: [],
      regimes_by_id: {},
      new_options: [
        {value: 0, label: 'Não'},
        {value: 1, label: 'Sim'},
      ],
      regime_id: null,
      new: 0,
      text: null,
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      schedule_grade_comments: {},
    };

    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.resetUpdated = this.resetUpdated.bind(this);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.regimes_select) && Object.keys(newProps.regimes_by_id).length && Object.keys(newProps.schedule_grade_comments).length) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        schedule_grade_comments: newProps.schedule_grade_comments,
        regimes_select: newProps.regimes_select,
        regimes_by_id: newProps.regimes_by_id,
        loaded: 1,
      });
    }
  }

  // Adiciono uma comentário na escala
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      schedule_id: this.props.schedule_id,
      schedule_grade_id: this.props.schedule_grade_id,
      text: this.state.text,
      new: this.state.new,
      regime_id: this.state.regime_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/grade/adicionar/comentario', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({schedule_grade_comments: responseJson.data, updated: 1});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  // Adiciono uma comentário na escala
  delete(event) {
    var schedule_grade_comment_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse comentário?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/comentario/' + schedule_grade_comment_id, { method: 'DELETE', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({schedule_grade_comments: responseJson.data, updated: 1});
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  resetUpdated(event) {
    this.setState({updated: 0});
  }
  


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Adicionar comentário</h3>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Comentário:</label>
        <input type="text" name="text" className="form-control" placeholder="Comentário" value={this.state.text} onChange={this.handleChange.bind(this, 'text')} />
      </div>
      <div className="col-md-3 form-group">
        <label>Regime:</label>
        <Select
          className="form-field-name"
          name="regime_id"
          value={this.state.regime_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'regime_id')}
          options={this.state.regimes_select}
        />
      </div>
      <div className="col-md-3 form-group">
        <label>Novo?</label>
        <Select
          className="form-field-name"
          name="new"
          value={this.state.new}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'new')}
          options={this.state.new_options}
        />
      </div>
    </div>
    <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> Adicionar comentário</button>
  </form>
  <hr/>
  {Object.keys(self.state.regimes_by_id).map(function(regime_id) {
    
    return(
      <div>
        <h3>{self.state.regimes_by_id[regime_id]}</h3>
        <table className="table table-hover table-stripped table-bordered">
          <thead>
            <tr>
              <th className="col-md-11">Comentário</th>
              <th className="col-md-1">Ações</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(self.state.schedule_grade_comments[regime_id]).map(function(k) {
              var comment = self.state.schedule_grade_comments[regime_id][k];
              return(
                <tr>
                  <td style={{width: '13%'}}>
                    <ScheduleGradeCommentsEdit schedule_grade_comment_id={comment.id} resetUpdated={self.resetUpdated} updated={self.state.updated} status={self.props.status} comments={comment.text} handleAlert={self.props.handleAlert} />
                </td>
                  <td style={{width: '13%'}}>
                    <button className="btn btn-danger button-inline" value={comment.id} onClick={self.delete}>
                      <i className="fa fa-fw fa-trash"></i>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <hr/>
      </div>
    );
  })}
</div>
    );
  }
}

export default ScheduleGradeCommentsTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeCommentsTab.js